import { render, staticRenderFns } from "./GrowerPricingDuplicateDialog.vue?vue&type=template&id=0ff67858&scoped=true"
import script from "./GrowerPricingDuplicateDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GrowerPricingDuplicateDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GrowerPricingDuplicateDialog.vue?vue&type=style&index=0&id=0ff67858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff67858",
  null
  
)

export default component.exports